// One bounded queue across all photo groups. Await in-flight uploads even on failure.
async function uploadPhotoBatch(
  { front, pictures = [], apprasing = [] },
  upload,
  { concurrency = 3, onUploaded = () => {} } = {},
) {
  const tasks = [
    { photo: front, type: 'front' },
    ...pictures.map((photo) => ({ photo, type: 'pictures' })),
    ...apprasing.map((photo) => ({ photo, type: 'apprasing' })),
  ];
  const urls = new Array(tasks.length);
  let cursor = 0;
  let failure;
  const worker = async () => {
    while (!failure && cursor < tasks.length) {
      const index = cursor++;
      try {
        const { photo, type } = tasks[index];
        const url = await upload(photo, type);
        if (!url)
          throw new Error(
            'No se pudo subir una de las fotos. Reintentá antes de publicar.',
          );
        urls[index] = url;
        onUploaded(url);
      } catch (error) {
        failure = failure || error;
      }
    }
  };
  if (!Number.isInteger(concurrency) || concurrency < 1)
    throw new Error('Concurrencia inválida');
  await Promise.all(
    Array.from({ length: Math.min(concurrency, tasks.length) }, worker),
  );
  if (failure) throw failure;
  return {
    frontURL: urls[0],
    picturesURL: urls.slice(1, 1 + pictures.length),
    apprasingURL: urls.slice(1 + pictures.length),
  };
}

module.exports = { uploadPhotoBatch };
